// AVAL : ouverture/fermeture du modal « Nouveau dossier » de l'Espace Marchés,
// en DÉLÉGATION d'événements (dans le bundle JS) au lieu d'un <script> inline.
//
// Pourquoi : un <script> inline dépend du nonce CSP. Avec Turbo + la rotation
// de session Warden au login, le nonce de la page ne correspond plus au nonce
// CSP enforcé → le script est bloqué ("Executing inline script violates CSP")
// et le bouton « Nouveau dossier » ne réagit plus jusqu'à un rechargement
// complet. Ici, les écouteurs sont posés UNE fois sur `document` (au chargement
// du bundle) et fonctionnent sur toutes les pages/navigations, sans dépendre
// du CSP.
//
// NB : l'anti-double-soumission (overlay, désactivation du bouton, confirmation)
// est géré par `app/views/espace_marches/_scripts.html.erb` (déjà en place), et
// les doublons sont bloqués côté SERVEUR par le Mutex de `creer`. On ne pose
// donc AUCUN garde de soumission ici : un 2e garde entrerait en conflit avec le
// `form.requestSubmit()` de la confirmation de `_scripts` (le POST serait bloqué
// et l'overlay tournerait à l'infini).

function modal() {
  return document.getElementById('em-new-modal')
}

function showModal() {
  const m = modal()
  if (!m) return
  m.hidden = false
  document.body.style.overflow = 'hidden'
  const field = m.querySelector('input[name="objet"]')
  if (field) field.focus()
}

function hideModal() {
  const m = modal()
  if (!m) return
  m.hidden = true
  document.body.style.overflow = ''
}

document.addEventListener('click', (event) => {
  if (event.target.closest('#em-new-open')) {
    showModal()
    return
  }
  if (event.target.closest('#em-new-close, #em-new-cancel')) {
    hideModal()
  }
})

document.addEventListener('keydown', (event) => {
  const m = modal()
  if (event.key === 'Escape' && m && !m.hidden) hideModal()
})
